import { computed } from 'vue'
import type { ComputedRef, Ref } from 'vue'
// types
import type { StrapiSiteFooter, StrapiSingleResponse } from '@ts-strapi/interfaces'
// hooks
import { useStrapiFetch } from '@api/strapi/use-strapi-fetch.hook'

interface StrapiSiteFooterHookReturn {
  refSiteFooter: ComputedRef<StrapiSiteFooter | null>
  refPending: Ref<boolean>
  refError: Ref<Error | null>
  refresh: () => Promise<void>
}

export const useStrapiSiteFooter = async (): Promise<StrapiSiteFooterHookReturn> => {
  const strapiFetch = useStrapiFetch()

  const { data, pending, error, refresh } = await useAsyncData(
    'strapi:site-footer',
    () => strapiFetch<StrapiSingleResponse<StrapiSiteFooter>>('/site-footer', {
      params: {
        'populate[brand][populate][socials]': 'true',
        'populate[companyColumn][populate][links]': 'true',
        'populate[policiesColumn][populate][links]': 'true',
        'populate[tutoringColumns][populate][links]': 'true',
        'populate[nearMeColumn][populate][links]': 'true',
        'populate[skillsColumns][populate][links]': 'true',
        'populate[resourcesColumns][populate][links]': 'true',
        'populate[reviewedOn][populate][platforms]': 'true',
        'populate[weAccept][populate][methods]': 'true',
        'populate[safeSecure][populate][seals]': 'true',
        'populate[bottomBar]': 'true',
      },
    }),
  )

  return {
    refSiteFooter: computed(() => data.value?.data ?? null),
    refPending: pending,
    refError: error as Ref<Error | null>,
    refresh: () => refresh(),
  }
}
